/**
 * storeAvailability.ts — the "All store availability" filter shared by
 * Admin > Products, Memberships and Packages, as on the corporate dashboard:
 * "Available in Store" / "Not Available in Store". Nothing picked, or both,
 * lists everything.
 */

export const STORE_IN = 'in_store';
export const STORE_OUT = 'not_in_store';
export const STORE_AVAILABILITY_OPTIONS = [
  { value: STORE_IN, label: 'Available in Store' },
  { value: STORE_OUT, label: 'Not Available in Store' },
];

/** True when a record that is (or isn't) in the store passes the picked values. */
export function matchesStoreAvailability(selected: readonly string[], inStore: boolean): boolean {
  return selected.length === 0 || selected.includes(inStore ? STORE_IN : STORE_OUT);
}
